<script>
import EnvironmentUtils from '@/utils/environmentUtils'
import Packagejson from '~/package.json'
import Config from '~/config/index'

export default
{
    name: 'about',

    render () 
    {
        return (
            <div id='about-view'>
                <p>
                    Cette application vous est offerte par {EnvironmentUtils.clientName} et est propulsée par la solution
                    <a href={Config.appWebsiteUrl} target='_system'> Ma Ville</a>.
                </p>
                <br />
                <p>
                    Nous espérons que votre expérience est la plus agréable possible, si ce n'est pas le cas (ou pour tout autre renseignement 🙂)
                    <a href={Config.contactUrl} target='_system'> contactez-nous ici</a>.
                </p>
                <br />
                <br />
                <p class='copyright'>
                    © 2020 Ma Ville v{Packagejson.version} '{Packagejson.release}'
                </p>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#about-view
{
    padding: 16px 1px;

    .copyright
    {
        font-size: 12px;
        color: var(--theme-text-color-extra-light);
    }
}
</style>



// WEBPACK FOOTER //
// src/views/About.vue